import Hourglass from '../../assets/images/Hourglass';
import React from 'react';

function LoadingSpinner({size=50, className='', ...props}) {
  return <Hourglass height={size} width={size} className={'hourglass-flip ' + className} {...props}/>
}

export default LoadingSpinner;